import React, { Component } from "react";
import GA from "../../components/GA/GA";
import SmoothEvent from "../../components/SmoothAnalytics/";
import "./About.css";

class About extends Component {
  componentDidMount(props) {
    this.props.changePage("about");
    GA("Page: About");
    SmoothEvent("pageload");
  }

  render() {
    return (
      <div className="page-container">
        <div className="content-spacer-1 spacer-bg-about"></div>

        <div className="content-container">
          <div className="content-container-background"></div>

          <div className="content-container-content">
            <h1>About Us</h1>
            <br />
            <h2>Fairy Clean</h2>
            <br />
            Fairy Clean was founded in 2015 to offer a high quality and reasonably priced cleaning services. At the
            moment we operate in the major part of North London and provide house cleaning, one-off spring cleaning, end
            of tenancy cleaning and other cleaning services.
            <br />
            <br />
            Most of our clients found us through recommendations.
            <br />
            <br />
            <h2>Our Staff</h2>
            <br />
            Finding a good and reliable cleaner is not an easy task and we are here to help you!
            <br />
            <br />
            Every cleaner in Fairy Clean has been interviewed in person, completed in-house training courses and had
            their background checked. Our cleaners are trustworthy, friendly and reliable. <br />
            <br />
            Book a regular visit and we will send you the same cleaner every week or fortnight.
            <br />
            <br />
            We recommend you to take advantage of our free key-holding service, so your house could be cleaned while you
            are away.
            <br />
            <br />
            <h2>Locations</h2>
            <br />
            We provide services in the major part of North London: Barnet, Borehamwood, Cockfosters, Colindale, Edgware,
            Enfield, Finchley, Hadley Wood, Hamstheath, Hendon, Mill Hill, Oakwood, Palmers Green, Southgate, Stanmore,
            Whetstone, Winchmore Hill, Wood Green.
            <br />
            <br />
            <br />
            <br />
            <div className="cleaning-tips-container">
              <div className="cleaning-tip-icon"></div>
              <i>
                To soften splatters inside the microwave, fill a cup with water add some lemon and microwave on high for
                a few minutes. The steam will loosen any baked on food so you can easily wipe it clean and it will smell
                fresh.
              </i>
              <div className="breaker"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
